import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactTooltip from "react-tooltip";
import { createNewEmployee } from "../create-new-employee";
import { getCsvEmployees } from "../get-csv-employees";
import { displayInvalidCSVModal } from "../displays/display-invalid-csv-modal";
import { translate as t } from "../../../infrastructure/translate/localization";
import { uploadMultipleEmployees } from "../displays/upload-multiple-employees";
import { hideModal } from "../../commons/hide-modal";
import CobeeButton from "../../../app/components/CobeeButton";

export default class UploadEmployeesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  async handleChangeFile(e) {
    const filename = e.target.files[0];
    this.setState({ isLoading: true });
    const csvProperties = await getCsvEmployees({
      type: "massiveUpload",
      filename,
    });
    if (csvProperties.isInvalid) {
      displayInvalidCSVModal(csvProperties.errorMessage);
    }
    this.setState({ isLoading: false });
    hideModal();

    this.upload.value = null;
  }

  render() {
    const { isLoading } = this.state;
    return (
      <main className="section">
        <ReactTooltip
          className="tooltipMessage"
          place="top"
          effect="solid"
          type="light"
          delayShow={500}
        />
        <div className="section-header">
          <h1 className="section-title">
            {t("upload-employees-section.upload-employees")}
          </h1>
          <div id="notification-card" />
        </div>
        {isLoading ? (
          <div className="section-container">
            <p>{t("common-messages.loading-data")}</p>
          </div>
        ) : (
          <div className="section-container">
            <div className="section-header">
              <p className="header-title">{t("employees-section.employees")}</p>
              <div className="header-actions">
                <div className="container-button">
                  <CobeeButton
                    styleType="secondary"
                    onClick={() => createNewEmployee()}
                  >
                    <FontAwesomeIcon icon="plus" alt="create" />
                    <p className="info-button">
                      {t("upload-employees-section.add-employee")}
                    </p>
                  </CobeeButton>
                </div>
                <div className="container-button">
                  <CobeeButton
                    styleType="secondary"
                    onClick={() =>
                      uploadMultipleEmployees({
                        callback: () => this.upload.click(),
                      })
                    }
                  >
                    <FontAwesomeIcon icon="user-friends" alt="create group" />
                    <p className="info-button">
                      {t("upload-employees-section.add-multiple-employees")}
                    </p>
                  </CobeeButton>
                </div>

                <input
                  id="workaround-upload"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  type="file"
                  ref={(ref) => {
                    this.upload = ref;
                  }}
                  style={{ display: "none" }}
                  onChange={(e) => this.handleChangeFile(e)}
                />
              </div>
            </div>
            <p className="section-description">
              {t("upload-employees-section.upload-spreadsheet-info")}
              <a
                className="cob-link"
                href={`${process.env.PUBLIC_URL}/downloadables/${t(
                  "upload-employees-section.eg-file"
                )}.xlsx`}
                rel="noopener noreferrer"
                download
              >
                {`${t("upload-employees-section.download-csv")} ${t(
                  "upload-employees-section.eg-file"
                )}.xlsx`}
              </a>
            </p>
            <div
              className="container-flex"
              id="table-error-employees-container"
            />
            <div
              className="container-flex"
              id="table-warning-employees-container"
            />
            <div
              className="container-flex"
              id="table-uploading-employees-container"
            />
          </div>
        )}
      </main>
    );
  }
}
